export const GET_COMPANY_INFOS = 'GET_COMPANY_INFOS'
export const GET_CURRENCIES = 'GET_CURRENCIES'
